import React from 'react';

import PillarOverviewSlider from '../../PillarOverviewSlider';

import './style.scss';

// FIXME: Add CMSable body text
const ThemesPillarOverview = ({ entities, entity, ...props }) => {
  const url = `${window.location.pathname}/themas`;

  return (
    <PillarOverviewSlider
      type="taxonomy"
      className="ThemesPillarOverview"
      url={url}
      subTitle="Bekijk alle thema's"
      introType="theme"
      title={entity.getIn(['field_label', 0, 'value'])}
      body={entity.getIn(['field_text', 0, 'processed'])}
      entities={entities}
      {...props}
    />
  );
};

export default ThemesPillarOverview;
